<template>
    <form v-if="dataBiopsySpecLN && IDLABSelected">
        <b-modal :active.sync="isComponentModalActive"
                 :full-screen.sync="isFullScreen"
                 has-modal-card  >
          <div class="modal-card">

                <header class="modal-card-head"  >
                    <section class="modal-card-body  "  >
                        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
                        <HeaderDecorate :showLabNo=true :idlab="IDLABSelected.idlab" />
                    </section>
                </header>

                <section class="modal-card-body"  >
<TemplateLoadStatus :detail-loading="templateDetailLoading" :detail-error="templateDetailError" @retry-detail="retryTemplateDetail" />


                    <DetailUsedPartFromRequestDataEachLab
                    :IDLABSelected ="IDLABSelected"/>




                    <nav class="level is-mobile">
                        <div class="level-left">
                            <div class="level-item">
                                <p class="is-size-5"> Status </p>
                            </div>
                            <div class="level-item">
                                <p v-if="dataBiopsySpecLN.status.id < 5 "  class="is-size-5 has-text-info"> &nbsp; {{ dataBiopsySpecLN.status.name }}  </p>
                                <p v-if="dataBiopsySpecLN.status.id >=5 && dataBiopsySpecLN.status.id <=6"  class="is-size-5 has-text-success"> &nbsp; {{ dataBiopsySpecLN.status.name }}  </p>
                                <p v-if="dataBiopsySpecLN.status.id === 7 "  class="is-size-5 has-text-danger"> &nbsp; {{ dataBiopsySpecLN.status.name }} </p>
                            </div>
                            <div class="level-item">
                                <b-icon icon="lock" type="is-danger"  v-if="dataBiopsySpecLN.status.id >=5 "  ></b-icon>
                                <b-icon icon="lock-open" type="is-success"  v-if="dataBiopsySpecLN.status.id < 5 "  ></b-icon>
                            </div>
                            <div class="level-item">
                                <p class="is-size-5"> Assigned for </p>
                                <p class="is-size-5 has-text-grey"> &nbsp; {{ dataBiopsySpecLN.assigned_to_user.name }}</p>
                            </div>
                            <div class="level-item" v-if="userIsAdmin && dataBiopsySpecLN.status.id !== 7 ">
                                <b-button size="is-medium"
                                          icon-left="minus-circle" @click="disableLab" >
                                    Disable
                                </b-button>
                            </div>
                        </div>
                    </nav>

                    <!--*************************************************************************-->
                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <h1 class="title" style="color: #167df0">
                                    <b-icon  icon="file-document"  size="is-small"></b-icon>
                                    {{headerInfoPrepare}}
                                </h1>
                            </div>
<!--                        <h1 class="title" style="color: #167df0">-->
<!--                            <b-icon  icon="file-document"  size="is-small"></b-icon>-->
<!--                            {{headerInfoPrepare}} -->
<!--                        </h1>-->
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <p class="is-size-6 has-text-grey"> My Templates </p>
                            </div>
                            <div class="level-item">

                                <b-select placeholder="Template" v-model="dataTemplateSelectedPrepare"  :disabled="!(userRoleFind(3) &&dataBiopsySpecLN.status.id <5)">
                                    <option
                                            v-for="dataTemplate in templateCatalogue"
                                            :value="dataTemplate.id"
                                            :key="dataTemplate.id">
                                        {{ dataTemplate.title }}
                                    </option>
                                </b-select>


                            </div>
                            <div class="level-item">
                                <b-button type="is-success"
                                          icon-right="plus"
                                          @click="addTemplate('editorDat_prepare')"
                                          :disabled="!(userRoleFind(3) &&dataBiopsySpecLN.status.id <5)"/>
                            </div>
                        </div>
                    </nav>
                    <hr>
                    <!--                    <vue-editor v-model="dataBiopsySpecLN.dat_prepare.dat"-->
                    <!--                                id="editorDat_prepare"-->
                    <!--                                :editor-toolbar="customToolbar"-->
                    <!--                                :disabled="!userRoleFind(4) || (dataAllContent.status.id === 5 || dataAllContent.status.id === 6 ) "-->
                    <!--                                 />-->

                    <vue-editor v-model="dataBiopsySpecLN.dat_prepare.dat"
                                id="editorDat_prepare"
                                :editor-toolbar="customToolbar"
                                :disabled="!(userRoleFind(3)&&dataBiopsySpecLN.status.id <5 )"
                                ref="editorDat_prepare"
                    />
                    <br>

<!--   headerInfoPrepare  plus     -->
                   <div  v-if="dataBiopsySpecLN && dataBiopsySpecLN.data_plus.dat_prepare.length>0"   >
                        <div v-for="dat_prepare_plus in  dataBiopsySpecLN.data_plus.dat_prepare" :key="dat_prepare_plus.id">
                            <TitlePlus :datUserWhoView="getNameAndSurname"
                                       :titleDisplay="headerPrepareInfoPlus"
                                       :plus=true />
                            <div class="box"  >
                                <div v-html="dat_prepare_plus.dat" ></div>
                            </div>
                            <FooterPlus  :user_rec="dat_prepare_plus.user_rec"
                                         :date_rec="dat_prepare_plus.date_rec"
                                         :time_rec="dat_prepare_plus.time_rec"
                                         :userIsAdmin="userIsAdmin"
                                         :idToDelete = "dat_prepare_plus.id.toString()"
                                         :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare_plus"
                                         :labKind = "IDLABSelected.kind"
                            />

                        </div>

                    </div>
                    <br>


                    <!--*************************************************************************-->
                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <h1 class="title" style="color: #167df0">
                                    <b-icon  icon="file-document"  size="is-small"></b-icon>
                                    Finding and Content
                                </h1>
                            </div>

                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <p class="is-size-6 has-text-grey"> My Templates </p>
                            </div>
                            <div class="level-item">

                                <b-select placeholder="Template" v-model="dataTemplateSelectedCt"  :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataBiopsySpecLN.status.id <5 && dataBiopsySpecLN.assigned_to_user.id === user_id)">
                                    <option
                                            v-for="dataTemplate in templateCatalogue"
                                            :value="dataTemplate.id"
                                            :key="dataTemplate.id">
                                        {{ dataTemplate.title }}
                                    </option>
                                </b-select>


                            </div>
                            <div class="level-item">
                                <b-button type="is-success"
                                          icon-right="plus"
                                          @click="addTemplate('editorDat_ct')"
                                          :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataBiopsySpecLN.status.id <5 && dataBiopsySpecLN.assigned_to_user.id === user_id)"/>
                            </div>
                        </div>
                    </nav>



                    <hr>
                    <vue-editor v-model="dataBiopsySpecLN.dat_ct.dat"
                                id="editorDat_ct"
                                :editor-toolbar="customToolbar"
                                :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataBiopsySpecLN.status.id <5 && dataBiopsySpecLN.assigned_to_user.id === user_id)"
                                ref="editorDat_ct"
                    />


                    <br>
  <!--              content plus      -->
                    <div   v-if="dataBiopsySpecLN && dataBiopsySpecLN.data_plus.dat_ct.length>0" >
                        <div v-for="dat_content_plus in  dataBiopsySpecLN.data_plus.dat_ct" :key="dat_content_plus.id">
                            <TitlePlus :datUserWhoView="getNameAndSurname"
                                       :titleDisplay="findingAndContentPlus"
                                       :plus=true />
                            <div class="box"  >
                                <div v-html="dat_content_plus.dat" ></div>
                            </div>
                            <FooterPlus  :user_rec="dat_content_plus.user_rec"
                                         :date_rec="dat_content_plus.date_rec"
                                         :time_rec="dat_content_plus.time_rec"
                                         :userIsAdmin="userIsAdmin"
                                         :idToDelete = "dat_content_plus.id.toString()"
                                         :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct_plus"
                                         :labKind = "IDLABSelected.kind"
                            />
                        </div>
                    </div>

                    <hr>
                    <!--*************************************************************************-->
                    <nav class="level">
                        <h1 class="title" style="color: #167df0">
                            <b-icon  icon="file-document"  size="is-small"></b-icon>
                            Add Images
                        </h1>
                    </nav>
                    <nav class="level">
                        <b-tooltip label="Attach Image"  position="is-right">
                            <b-button
                                    icon-right="paperclip"
                                    type="is-success"
                                    @click="addImageAttach"
                                    :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataBiopsySpecLN.status.id <5 && dataBiopsySpecLN.assigned_to_user.id === user_id)">Add Images</b-button>
                        </b-tooltip>
                    </nav>
                    <hr>
                    <ThumbnailImageList  :modeThumbnailImageList="modeThumbnailImageList" v-if="dataBiopsySpecLN.img.dat.length>0"
                                         :dataPassThruImageList="dataPassThruImageList"
                                         @deleteImage="deleteImage" />
                    <hr  v-if="dataBiopsySpecLN.img.dat.length>0">
                    <br>


                    <!--   images plus  -->
                    <div   v-if="dataBiopsySpecLN && dataBiopsySpecLN.data_plus.img.length>0" >
                        <div v-for=" img in dataBiopsySpecLN.data_plus.img" :key="img.idtime">
                            <TitlePlus :datUserWhoView="getNameAndSurname"
                                       :titleDisplay="ImagePlus"
                                       :plus=true />
                            <br>
                            <ThumbnailImageList    :modeThumbnailImageList="modeThumbnailImageList" :dataPassThruImageList="dataPassThruImageListPlus(img.idtime)"  :plus="false"  />
                            <FooterPlus  :user_rec="getUserRecImgPlusByIdTime(img.idtime)"
                                         :date_rec="getDateRecImgPlusByIdTime(img.idtime)"
                                         :time_rec="getTimeRecImgPlusByIdTime(img.idtime)"
                                         :userIsAdmin="userIsAdmin"
                                         :idToDelete = "img.idtime.toString()"
                                         :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images_plus"
                                         :labKind = "IDLABSelected.kind"
                            />
                            <br>
                        </div>
                    </div>



                    <!--*************************************************************************-->

                    <nav class="level">
                        <h1 class="title" style="color: #167df0"> <b-icon
                                icon="codepen"
                                size="is-small">
                        </b-icon>  Classification of Diseases</h1>
                    </nav>
                    <nav class="level">
                        <b-tooltip label="Add More Disease Code"  position="is-right">
                            <b-button
                                    type="is-success"
                                    icon-right="plus"
                                    @click="addNewDiseaseCode"
                                    :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataBiopsySpecLN.status.id <5 && dataBiopsySpecLN.assigned_to_user.id === user_id)"
                            />

                        </b-tooltip>
                    </nav>
                    <br>

                    <b-table
                            :data="isEmpty ? [] : dataBiopsySpecLN.diag_code.dat"
                            bordered
                            striped
                            narrowed
                            hoverable
                            focusable
                            mobile-cards>


                            <b-table-column   label="Chapter"  v-slot="props">
                                {{ props.row.level1Name }}
                            </b-table-column>
                            <b-table-column   label="Body System" v-slot="props">
                                {{ props.row.level2Name }}
                            </b-table-column>
                            <b-table-column   label="Organ/Tissue" v-slot="props">
                                {{ props.row.level3Name }}
                            </b-table-column>
                            <b-table-column   label="Character/Subcategories" v-slot="props">
                                {{ props.row.level4Name }}
                            </b-table-column>
                            <b-table-column   label="Extensions" v-slot="props">
                                {{ props.row.level5Name }}
                            </b-table-column>
                            <b-table-column   label="%" v-slot="props">
                                {{ props.row.labDiseasecodeAccurateName }}
                            </b-table-column>

                            <b-table-column   label="Unclassified Descriptions" v-slot="props" >
                                {{ props.row.unClassifiedCodes }}
                            </b-table-column>


                            <b-table-column   label="Remark" v-slot="props">
                                {{ props.row.comment }}
                            </b-table-column>





                            <b-table-column   label="#" v-slot="props">
                                <b-button type="is-danger" icon-right="delete" @click="deleteLabDiseasecodeRecWithLabID(props.row.ID)" :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataBiopsySpecLN.status.id <5 && dataBiopsySpecLN.assigned_to_user.id === user_id)" />
                            </b-table-column>



                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                                icon="emoticon-sad"
                                                size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>Nothing here.</p>
                                </div>
                            </section>
                        </template>
                    </b-table>
<!--   diag plus  -->
                    <div  v-for="diag_code_plus in dataBiopsySpecLN.data_plus.diag_code" :key="diag_code_plus.idtime">

                        <TitlePlus
                                :datUserWhoView="getNameAndSurname"
                                :titleDisplay="ClassificationOfDiseases"
                                :plus=true
                        />
                        <b-table         :data="diag_code_plus.dat"
                                         bordered
                                         striped
                                         narrowed
                                         hoverable
                                         focusable
                                         mobile-cards
                        >
                            <b-table-column   label="Chapter" v-slot="props">
                                {{ props.row.level1Name }}
                            </b-table-column>
                            <b-table-column   label="Body System" v-slot="props">
                                {{ props.row.level2Name }}
                            </b-table-column>
                            <b-table-column   label="Organ/Tissue" v-slot="props">
                                {{ props.row.level3Name }}
                            </b-table-column>
                            <b-table-column   label="Character/Subcategories" v-slot="props">
                                {{ props.row.level4Name }}
                            </b-table-column>
                            <b-table-column   label="Extensions" v-slot="props">
                                {{ props.row.level5Name }}
                            </b-table-column>
                            <b-table-column  label="Unclassified Descriptions" v-slot="props">
                                {{ props.row.unClassifiedCodes }}
                            </b-table-column>
                            <b-table-column  label="%" v-slot="props">
                                {{ props.row.labDiseasecodeAccurateName }}
                            </b-table-column>
                            <b-table-column  label="Remark" v-slot="props">
                                {{ props.row.comment }}
                            </b-table-column>

                        </b-table>

                        <FooterPlus  :user_rec="diag_code_plus.dat[0].user_rec"
                                     :date_rec="diag_code_plus.dat[0].date_rec"
                                     :time_rec="diag_code_plus.dat[0].time_rec"
                                     :userIsAdmin="userIsAdmin"
                                     :idToDelete = "diag_code_plus.idtime.toString()"
                                     :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code_plus"
                                     :labKind = "IDLABSelected.kind"
                        />
                    </div>

                </section>

                <footer class="modal-card-foot">
                    <div class="container" style=" width: 100vw; margin-left: 10px;">

                        <nav class="level" style="width:100vw;">
                            <div class="level-left">
                                <div class="level-item">
                                    <b-button type="is-danger"
                                              icon-left="close"  @click="closeModal"   >
                                        Close
                                    </b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-warning" icon-left="cloud-upload"   v-if="userRoleFind(3)&&dataBiopsySpecLN.status.id <5"   @click="updateData(3)"  > Save Prepare</b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"   v-if="(userRoleFind(4) )&&dataBiopsySpecLN.status.id <5 && dataBiopsySpecLN.assigned_to_user.id === user_id "    @click="updateData(4)"  > Save Content to Draft</b-button>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"      v-if="(userRoleFind(4) ) &&dataBiopsySpecLN.status.id <5 && dataBiopsySpecLN.assigned_to_user.id === user_id "   @click="updateData(5)"  > Save Content to Publish Incomplete</b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"     v-if="(userRoleFind(4) ) &&dataBiopsySpecLN.status.id <6 && dataBiopsySpecLN.assigned_to_user.id === user_id "   @click="updateData(6)"  > Save Content to Publish Complete</b-button>
                                </div>

                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                            </div>
                        </nav>
                    </div>
                </footer>

          </div>
        </b-modal>
     <UploadFiles  v-if="isModalUploadFiles"
                   :idlab=null
                   :plus=false
                   @close="closeAddImageAttach"
                   @closeWithData="closeAddImageAttachWithData"/>




     <SelectDiseaseCode v-if="isModalSelectDiseaseCode"
                        @close="closeSelectDiseaseCode"
                        @closeWithChange="closeSelectDiseaseCode_WithChange" />




     <DisableDlg   v-if="isDisableDlg"
                   ref="DisableDlg"
                   @close="closeDisableDlg"
                   @closeWithChange="closeDisableDlgWithChange"  />



    </form>
</template>

<script>
import templateCatalogue from '@/mixins/templateCatalogue'
    /* eslint-disable no-console */
    import axios from "axios";
    import {
            getBaseURLAvartar ,
            getBaseURLforBackEnd ,
            getConfigAxios   ,
            LOCATE_ENDPOINT_UPDATEEACH_KINDLAB ,
            LOCATE_ENDPOINT_VIEWEACH_KINDLAB ,
            genUUID,
            DATABIOPSPECLN_MODEL}  from '@/utils.js'
    import {mapState} from "vuex";

    import SelectDiseaseCode from "./SelectDiseaseCode";
    import userRoleFind from "../../mixins/methods/userRoleFind";
    import UploadFiles from "../UtilsComponents/UploadFiles";
    import ThumbnailImageList from "../UtilsComponents/ThumbnailImageList";
    import { VueEditor } from "vue2-editor"
    import htmlToText from "html-to-text";

    import DisableDlg from "./DisableDlg";
    import HeaderDecorate from "./DecorateComponents/HeaderDecorate";

    import globalconst from "../../mixins/globalconst";
    import TitlePlus from "./Plus/TitlePlus";
    import FooterPlus from "./Plus/FooterPlus";
    import DetailUsedPartFromRequestDataEachLab from "../UtilsComponents/DetailUsedPartFromRequestDataEachLab";




    export default {
        name: "EditDocLabBiopsy" ,
        components:{
            VueEditor,
            SelectDiseaseCode,
            UploadFiles,
            ThumbnailImageList,
            DisableDlg,
            HeaderDecorate,
            TitlePlus,
            FooterPlus,
            DetailUsedPartFromRequestDataEachLab
        },
        mixins:[templateCatalogue,globalconst,userRoleFind],
        mounted() {
            // console.log("mount edit docLab")
            // console.log(checkUserRole())
        },
        computed:{
            ...mapState({
                OPDSelected : state => state.opd_target.opd_selected,
                user_id : state => state.master_data.user_id,
                userIsAdmin : state => state.master_data.userIsAdmin,
                clientIP : state => state.master_data.clientIP,
                user_role : state => state.master_data.user_role,
                access_token: state => state.master_data.access_token,
            }) ,
            getNameAndSurname: function(){
                // return 'test'
                const userFullName = localStorage.getItem('user_name_surname')
                return  `<p class="has-text-weight-light has-text-grey-lighter" style="color: #00b89c; padding-top: 15px"> View by ${userFullName}
                          ${this.dataBiopsySpecLN.current_date}
                          ${this.dataBiopsySpecLN.current_time} </p>`
                // return localStorage.getItem('user_name_surname')
            },
            getTextFromPrepareHTML:function () {
                return  htmlToText.fromString(this.dataBiopsySpecLN.dat_prepare.dat, {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            },
            getTextFromContentHTML:function () {
                return  htmlToText.fromString( this.dataBiopsySpecLN.dat_ct.dat, {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            },
            lock3 : function() {
                return   this.userRoleFind(3) && (this.dataBiopsySpecLN.status.id >= 5)
            },
            lock4 : function() {
                return  this.userRoleFind(4) && (this.dataBiopsySpecLN.status.id >= 5)
            },
            getHTMLParse(){
                return  JSON.parse(JSON.stringify(this.dataAllContent.dat))
            },
            dataPassThruImageList: function () {
                // [ { id: tmpID ,
                //     file : null,
                //     urlTempUploaded: tmpUrl,
                //     title : vm.dataAllContent.img.dat[i].title,
                //     fileNameUploaded:  vm.dataAllContent.img.dat[i].file ,
                //     fresh : false  } ]
                return this.dataBiopsySpecLN.img.dat.map(dat => {
                    // console.log(dat)
                    return   { id: genUUID(5) ,
                               file : null,
                               urlTempUploaded:
                                   dat.fresh ? `${getBaseURLAvartar()}/temp/${dat.file}` :   `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                               title : dat.title,
                               fileNameUploaded: dat.file,
                               fresh : false  }

                })
            }
        },
        props:{
            IDLABSelected: null
        },
        methods:{

            dataPassThruImageListPlus(_idtime) {
                if(this.dataBiopsySpecLN.data_plus.img.length>0) {
                    const member = this.dataBiopsySpecLN.data_plus.img.find(data => data.idtime === _idtime)
                    var tmpArr = []
                    for (var i = 0; i <= member.id.length - 1; i++) {
                        const tmp = {
                            id: member.id[i],
                            file: null,
                            urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${member.file[i]}`,
                            title: member.title[i],
                            fileNameUploaded: member.file[i],
                            fresh: false
                        }
                        tmpArr.push(tmp)
                    }
                    return tmpArr
                }else{
                    return []
                }
            },
            getTimeRecImgPlusByIdTime(_idtime){
                const member  = this.dataBiopsySpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.time_rec[0]
            },
            getDateRecImgPlusByIdTime(_idtime){
                const member  = this.dataBiopsySpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.date_rec[0]
            },
            getUserRecImgPlusByIdTime(_idtime){
                const member  = this.dataBiopsySpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.user_rec[0]
            },
            //**********************************************************************************************************
            closeDisableDlgWithChange(){
                this.isDisableDlg = false
                this.dataBiopsySpecLN.status.id = 7
                this.dataBiopsySpecLN.status.name = "Disabled"
            },
            closeDisableDlg(){
                this.isDisableDlg = false
            },
            disableLab(){
                this.isDisableDlg = true
            },
            addTemplate(editorTarget) { return this.insertCachedTemplate(editorTarget) },
            loadData(){
                const datTo = {
                    "ln": this.IDLABSelected.idlab,
                    "ip": this.clientIP
                }
                const vm = this
                this.isFullScreenSearching = true

                if((this.IDLABSelected.kind).toUpperCase() === "BIOPSY") {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                    axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.BIOPSY}`,datTo,getConfigAxios())
                        .then(res=>{
                            vm.dataBiopsySpecLN = res.data
                            // trasnsform base64 --> regular string
                            vm.dataBiopsySpecLN.dat_prepare.dat = Buffer.from(vm.dataBiopsySpecLN.dat_prepare.dat, 'base64').toString('utf-8')
                            vm.dataBiopsySpecLN.dat_ct.dat = Buffer.from(vm.dataBiopsySpecLN.dat_ct.dat, 'base64').toString('utf-8')


                            for(var i = 0; i <  vm.dataBiopsySpecLN.img.dat.length ; i++){
                                const tmpID = genUUID(5)
                                const tmpUrl = `${getBaseURLAvartar()}/${vm.dataToChild.idlab}/${vm.dataBiopsySpecLN.img.dat[i].file}`
                                const tmpDat = { id: tmpID ,
                                    file : null,
                                    urlTempUploaded: tmpUrl,
                                    title : vm.dataBiopsySpecLN.img.dat[i].title,
                                    fileNameUploaded:  vm.dataBiopsySpecLN.img.dat[i].file ,
                                    fresh : false  }
                                vm.dataPassThruImageList.push(tmpDat)
                            }
                            vm.isFullScreenSearching = false
                        })
                        .catch(err=>{
                            console.log(err)

                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                            }
                        })
                        .finally(()=>{
                            vm.isFullScreenSearching = false
                        })
                }
            },
            deleteImage(fileNameUploaded){
                 // console.log(fileNameUploaded)
                 // console.log(this.dataBiopsySpecLN.img.dat.find( m )
                 const member = this.dataBiopsySpecLN.img.dat.find(member => member.file === fileNameUploaded  )
                 const memberIndex = this.dataBiopsySpecLN.img.dat.indexOf(member)
                 this.dataBiopsySpecLN.img.dat.splice(memberIndex,1)

            },
            addImageAttach(){
                this.isModalUploadFiles = true
            },
            closeAddImageAttach(){
                this.isModalUploadFiles = false
            },
            closeAddImageAttachWithData(dat){

                if(dat.file){

                    const tmp = {
                            "file":   dat.fileNameUploaded,
                            "title":  dat.title,
                            "fresh": true
                    }
                    this.dataBiopsySpecLN.img.dat.push(tmp)
                }

                this.isModalUploadFiles = false
            },
            deleteLabDiseasecodeRecWithLabID(id){
                  // console.log(id)
                const member = this.dataBiopsySpecLN.diag_code.dat.find( member => member.ID === id)
                const memberIndex = this.dataBiopsySpecLN.diag_code.dat.indexOf(member)
                // console.log(memberIndex)
                this.dataBiopsySpecLN.diag_code.dat.splice(memberIndex,1)
                // console.log(this.labDiseasecodeRecWithLabID)
            },
            closeSelectDiseaseCode_WithChange(dataToSave){
                // console.log(dataToSave)
                this.dataBiopsySpecLN.diag_code.dat.push(dataToSave)
                // console.log(this.labDiseasecodeRecWithLabID)
            },
            closeSelectDiseaseCode(){
                this.isModalSelectDiseaseCode = false
            },
            addNewDiseaseCode(){
                this.isModalSelectDiseaseCode = true
            },

            getMyTemplateLocal() { return this.ensureTemplateList() },

            closeModal(){
                this.isComponentModalActive = false
                this.$emit('close')
            },



            updateData(idstatus){
                if (this.isSavingBiopsy || (this.IDLABSelected.kind || '').toUpperCase() !== 'BIOPSY') return

                // console.log(this.dataBiopsySpecLN)

               //  // update ICD10 Code
               var arrIndex = []
               var arrID_GRP_ICD10 = []
               var arrID_ACCURATE = []
               var arrUnclassifiedCode = []
               var arrCommentTxt  = []
               //  clear null to empty string
                for(var j =0;j<this.dataBiopsySpecLN.diag_code.dat.length;j++) {

                    if (this.dataBiopsySpecLN.diag_code.dat[j].level5ID === null)  {
                        this.dataBiopsySpecLN.diag_code.dat[j].level5ID = ""
                    }
                    if (this.dataBiopsySpecLN.diag_code.dat[j].level4ID === null)  {
                        this.dataBiopsySpecLN.diag_code.dat[j].level4ID = ""
                    }
                    if (this.dataBiopsySpecLN.diag_code.dat[j].level3ID === null)  {
                        this.dataBiopsySpecLN.diag_code.dat[j].level3ID = ""
                    }
                    if (this.dataBiopsySpecLN.diag_code.dat[j].level2ID === null )  {
                        this.dataBiopsySpecLN.diag_code.dat[j].level2ID = ""
                    }
                    if (this.dataBiopsySpecLN.diag_code.dat[j].level1ID === null ) {
                        this.dataBiopsySpecLN.diag_code.dat[j].level1ID = ""
                    }


                }

              for(var i =0;i<this.dataBiopsySpecLN.diag_code.dat.length;i++) {

                  if (this.dataBiopsySpecLN.diag_code.dat[i].level5ID !== "") {
                      arrID_GRP_ICD10.push( this.dataBiopsySpecLN.diag_code.dat[i].level5ID)
                  } else if (this.dataBiopsySpecLN.diag_code.dat[i].level4ID !== "")  {
                      arrID_GRP_ICD10.push( this.dataBiopsySpecLN.diag_code.dat[i].level4ID)
                  } else if (this.dataBiopsySpecLN.diag_code.dat[i].level3ID !== "")  {
                      arrID_GRP_ICD10.push( this.dataBiopsySpecLN.diag_code.dat[i].level3ID)
                  } else if (this.dataBiopsySpecLN.diag_code.dat[i].level2ID !== "")  {
                      arrID_GRP_ICD10.push( this.dataBiopsySpecLN.diag_code.dat[i].level2ID)
                  } else if (this.dataBiopsySpecLN.diag_code.dat[i].level1ID !== "") {
                      arrID_GRP_ICD10.push( this.dataBiopsySpecLN.diag_code.dat[i].level1ID)
                  }else {
                      arrID_GRP_ICD10.push(null)
                  }


                  arrIndex.push(this.dataBiopsySpecLN.diag_code.dat[i].ID)
                  arrID_ACCURATE.push(this.dataBiopsySpecLN.diag_code.dat[i].labDiseasecodeAccurateID)
                  arrUnclassifiedCode.push(this.dataBiopsySpecLN.diag_code.dat[i].unClassifiedCodes)
                  arrCommentTxt.push(this.dataBiopsySpecLN.diag_code.dat[i].comment)
              }


                // console.log(JSON.stringify(this.dataBiopsySpecLN))
               var arrImage = []
                for(var k = 0;k<this.dataBiopsySpecLN.img.dat.length;k++) {
                    arrImage.push({"file": this.dataBiopsySpecLN.img.dat[k].file , "title":this.dataBiopsySpecLN.img.dat[k].title ,"fresh": this.dataBiopsySpecLN.img.dat[k].fresh })
                }

                // ***************************
                //  update code/main cytology
                // ***************************
                const vm = this
                const datTo = {
                    "ln": this.IDLABSelected.idlab,
                    "ip": this.clientIP ,
                    "status" : idstatus,
                    "data": {
                        "dat_prepare": this.dataBiopsySpecLN.dat_prepare.dat,
                        "dat_prepare_txt": this.getTextFromPrepareHTML,
                        "ct_dat_html" : this.dataBiopsySpecLN.dat_ct.dat,
                        "ct_dat_html_txt" : this.getTextFromContentHTML,
                        "lab_diseasecode_labid" :{
                                                    "arrindex" : arrIndex,
                                                    "arrid_grp_icd10": arrID_GRP_ICD10,
                                                    "arrid_accurate": arrID_ACCURATE,
                                                    "arrunclassifiedcode":arrUnclassifiedCode,
                                                    "arrcommenttxt": arrCommentTxt
                                                 },
                        "lab_img_path":arrImage
                    }
                }


                this.isSavingBiopsy = true
                this.isFullScreenSearching = true
                if((this.IDLABSelected.kind).toUpperCase() === "BIOPSY") {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`  
                    axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_UPDATEEACH_KINDLAB.BIOPSY}`,datTo,getConfigAxios())
                        .then((res)=>{
                            const savedText = res.data && res.data.saved_text
                            if (savedText) {
                                // Preserve edits made after this request was submitted.
                                if (Object.prototype.hasOwnProperty.call(savedText, 'dat_prepare') &&
                                    vm.dataBiopsySpecLN.dat_prepare.dat === datTo.data.dat_prepare) {
                                    vm.dataBiopsySpecLN.dat_prepare.dat = savedText.dat_prepare
                                }
                                if (Object.prototype.hasOwnProperty.call(savedText, 'ct_dat_html') &&
                                    vm.dataBiopsySpecLN.dat_ct.dat === datTo.data.ct_dat_html) {
                                    vm.dataBiopsySpecLN.dat_ct.dat = savedText.ct_dat_html
                                }
                            }
                            vm.dataBiopsySpecLN.status.id = idstatus
                            const warnings = res.data && res.data.warnings
                            const hasWarnings = Array.isArray(warnings) && warnings.length > 0
                            const reference = (res.data && res.data.request_id) || ''
                            vm.$buefy.toast.open({
                                message: hasWarnings
                                    ? `บันทึกสำเร็จ แต่มีงานหลังบันทึกที่ต้องตรวจสอบ (รหัสอ้างอิง: ${reference})`
                                    : 'Update data completely!',
                                type: hasWarnings ? 'is-warning' : 'is-success'
                            })
                        })
                        .catch(err=>{
                            const result = (err.response && err.response.data) || {}
                            const messages = {
                                invalid_input: 'ข้อมูลที่ส่งไม่ถูกต้อง กรุณาตรวจสอบช่องที่ระบุ',
                                unsupported_characters: 'มีอักขระที่ฐานข้อมูลไม่รองรับ กรุณาตรวจสอบช่องที่ระบุ',
                                image_missing: 'ไม่พบไฟล์รูปชั่วคราว กรุณาอัปโหลดรูปใหม่',
                                image_conflict: 'ชื่อไฟล์รูปซ้ำกับไฟล์เดิมที่มีเนื้อหาต่างกัน กรุณาอัปโหลดใหม่',
                                status_conflict: 'ข้อมูลสถานะผลตรวจไม่สอดคล้อง กรุณาเปิดผลตรวจใหม่',
                                not_found: 'ไม่พบรายการตรวจ biopsy นี้',
                                save_outcome_unknown: 'ยังยืนยันผลการบันทึกไม่ได้ กรุณาเปิดผลตรวจใหม่เพื่อตรวจสอบก่อนบันทึกซ้ำ',
                                save_failed: 'บันทึกไม่สำเร็จ กรุณาแจ้งรหัสอ้างอิงให้ผู้ดูแลตรวจสอบ'
                            }
                            const message = messages[result.code] || (err.response
                                ? 'บันทึกไม่สำเร็จ กรุณาตรวจสอบการเข้าสู่ระบบหรือแจ้งผู้ดูแล'
                                : 'ไม่ได้รับคำตอบจากระบบ กรุณาเปิดผลตรวจใหม่เพื่อตรวจสอบก่อนบันทึกซ้ำ')
                            // Buefy renders dialog messages as HTML; escape server fields.
                            const escapeHtml = value => String(value).replace(/[&<>"']/g, char => ({
                                '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
                            }[char]))
                            const characters = Array.isArray(result.unsupported_characters)
                                ? result.unsupported_characters.slice(0, 12)
                                    .map(item => `${item.character} (${item.codepoint})`).join(', ')
                                : ''
                            const characterHint = characters ? ` อักขระที่ไม่รองรับ: ${characters}` : ''
                            const field = result.field ? ` ช่อง: ${result.field}` : ''
                            const reference = result.request_id ? ` รหัสอ้างอิง: ${result.request_id}` : ''
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: escapeHtml(message + field + characterHint + reference),
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })


                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                            }
                        })
                        .finally(()=>{
                            vm.isFullScreenSearching = false
                            vm.isSavingBiopsy = false
                        })
                }
            },













        },
        data(){
            return {
                //  dataPrePareToAdd : {
                //     // condition ? exprIfTrue : exprIfFalse
                //     'level1ID': this.level1Selected ? this.level1Selected.id : '',
                //     'level1Name': this.level1Selected ? this.level1Selected.name : '' ,
                //     'level2ID': this.level2Selected ? this.level2Selected.id : '',
                //     'level2Name': this.level2Selected ? this.level2Selected.name : '' ,
                //     'level3ID': this.level3Selected ?  this.level3Selected.id : '',
                //     'level3Name': this.level3Selected ? this.level3Selected.name :'',
                //     'level4ID': this.level4Selected ? this.level4Selected.id : '',
                //     'level4Name': this.level4Selected ? this.level4Selected.name : '',
                //     'level5ID': this.level5Selected ? this.level5Selected.id : '',
                //     'level5Name':this.level5Selected ? this.level5Selected.name : '',
                //     'labDiseasecodeAccurateID': this.diseasecodeAccurateSelected ? this.diseasecodeAccurateSelected.id : '',
                //     'labDiseasecodeAccurateName':this.diseasecodeAccurateSelected ? this.diseasecodeAccurateSelected.name :'',
                //     'comment' : this.commentTxt
                // },


                // [{"ID":"8939077578","level1ID":"EZ2BX2ZD7X9QWELM","level1Name":"Inflammation","level2ID":"FF084BE0776A1099AF03","level2Name":"TEST","level3ID":null,"level3Name":null,"level4ID":null,"level4Name":null,"level5ID":null,"level5Name":null,"labDiseasecodeAccurateID":null,"labDiseasecodeAccurateName":null,"unClassifiedCodes":null,"comment":null},
                //  {"ID":"6160866119","level1ID":"J88XP2ASM4F3CZRE","level1Name":"Neoplasia","level2ID":"EDB84AC62BA013DF09BF","level2Name":"test2","level3ID":"CD02356E62180D97255A","level3Name":"456456","level4ID":null,"level4Name":null,"level5ID":null,"level5Name":null,"labDiseasecodeAccurateID":null,"labDiseasecodeAccurateName":null,"unClassifiedCodes":null,"comment":null}]

                labDiseasecodeRecWithLabID: [
                    // { 'ID': '' ,'level1ID': null, 'level1Name': '','level2ID': null, 'level2Name': '','level3ID': null, 'level3Name': '', 'level4ID': null, 'level4Name': '', 'level5ID': null, 'level5Name': '','labDiseasecodeAccurateID': 1, 'labDiseasecodeAccurateName': null, 'unClassifiedCodes' : null  , 'comment' : null}
                ] ,
                isModalSelectDiseaseCode : false,
                isModalUploadFiles : false,
                dataTemplateSelectedCt : null,
                dataTemplateSelectedPrepare : null,
                dataTemplates: null,
                isComponentModalActive : false,
                isFullScreen : true ,
                isFullScreenSearching : false,
                isSavingBiopsy: false,
                activeTab : 0,
                dataAllContent : {
                    "dat": "",
                    "dat_prepare": "",
                    "status": "",
                    "status_id": -1,
                    "assigned_to_user" : -1
                },
                customToolbar: [
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    // ["image", "code-block"],
                    [ "code-block"],
                    [{ 'color': [] }, { 'background': [] }],
                    ['link'],
                ],
                isEmpty : false,
                modeThumbnailImageList : "edit",
                modeUploadFile : "edit",
                dataBiopsySpecLN : DATABIOPSPECLN_MODEL ,
                isDisableDlg : false,





            }
        },
        watch:{
            'dataBiopsySpecLN.status.id' : function (val) {
                    if(val === 5){
                        this.modeThumbnailImageList = 'view'
                    }
            },
            // isComponentModalActive:{
            //     immediate : true,
            //     handler: function (val) {
            //            // console.log('Edit biopsy wakeup'+val+ this.IDLABSelected.id)
            //         if(val){
            //             console.log( JSON.stringify( this.IDLABSelected))
            //         }
            //
            //     }
            // }
        }

    }
</script>

<style scoped>
    .rows{
        display: flex;
        flex-direction: column;
    }
</style>